<router-outlet></router-outlet>
<router-outlet name="my-profile"></router-outlet>

<input type="hidden" name="packageVersion" [value]="packageVersion">
